// assets
import AuditOutlined from '@ant-design/icons/AuditOutlined';
import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import EyeOutlined from '@ant-design/icons/EyeOutlined';
import FileSearchOutlined from '@ant-design/icons/FileSearchOutlined';
import FundViewOutlined from '@ant-design/icons/FundViewOutlined';
import LineChartOutlined from '@ant-design/icons/LineChartOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import ProjectOutlined from '@ant-design/icons/ProjectOutlined';
import WarningOutlined from '@ant-design/icons/WarningOutlined';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  AuditOutlined,
  DatabaseOutlined,
  DollarOutlined,
  EyeOutlined,
  FileSearchOutlined,
  FundViewOutlined,
  LineChartOutlined,
  ProfileOutlined,
  ProjectOutlined,
  WarningOutlined
};

// ==============================|| MENU ITEMS - MODULES ||============================== //

const other: NavItemType = {
  id: 'other',
  title: 'Modules',
  type: 'group',
  children: [
    {
      id: 'overview',
      title: 'Overview',
      type: 'item',
      url: '/overview',
      icon: icons.FundViewOutlined
    },
    {
      id: 'asset-viewer',
      title: 'Asset Viewer',
      type: 'item',
      url: '/asset-viewer',
      icon: icons.EyeOutlined,
      disabled: false
    },
    {
      id: 'asset-inventory',
      title: 'Asset Inventory',
      type: 'item',
      url: '/asset-inventory',
      icon: icons.DatabaseOutlined,
      disabled: false
    },
    {
      id: 'work-order',
      title: 'Work Order',
      type: 'collapse',
      icon: icons.ProfileOutlined,
      children: [
        {
          id: 'create-task',
          title: 'Create Task',
          type: 'item',
          url: '/work-order/create',
          disabled: false
        },
        {
          id: 'manage-tasks',
          title: 'Manage Tasks',
          type: 'item',
          url: '/work-order/tasks',
          disabled: false
        },
        {
          id: 'my-tasks',
          title: 'My Tasks',
          type: 'item',
          url: '/work-order/my-tasks',
          disabled: false
        },
        {
          id: 'manage-task-types',
          title: 'Manage Task Types',
          type: 'item',
          url: '/work-order/task-types',
          disabled: false
        }
      ]
    },
    {
      id: 'prediction',
      title: 'Prediction',
      type: 'item',
      url: '/prediction',
      icon: icons.LineChartOutlined,
      disabled: true
    },
    {
      id: 'operational-planning',
      title: 'Operational Planning',
      type: 'collapse',
      icon: icons.ProjectOutlined,
      children: [
        {
          id: 'treatment-assignment',
          title: 'Treatment Assignment',
          type: 'item',
          url: '/operational-planning/assignments',
          disabled: false
        },
        {
          id: 'treatment-summary',
          title: 'Treatment Summary',
          type: 'item',
          url: '/operational-planning/city-summary',
          disabled: false
        },
        {
          id: 'operational-overview',
          title: 'Operational Planning Overview',
          type: 'item',
          url: '/operational-planning',
          disabled: false
        }
      ]
    },
    {
      id: 'Planning',
      title: 'Capital Planning',
      type: 'collapse',
      icon: icons.DollarOutlined,
      children: [
        // {
        //   id: 'treatment-setting',
        //   title: 'Treatment Setting',
        //   type: 'item',
        //   url: '/treatment-setting',
        //   disabled: true
        // },
        // {
        //   id: 'deterioration-setting',
        //   title: 'Deterioration Setting',
        //   type: 'item',
        //   url: '/deterioration-setting',
        //   disabled: true
        // },
        // {
        //   id: 'budget-setting',
        //   title: 'Budget Setting',
        //   type: 'item',
        //   url: '/budget-setting',
        //   disabled: true
        // },
        {
          id: 'scenario-setting',
          title: 'Scenario Setting',
          type: 'item',
          url: '/scenario-setting',
          disabled: false,
          target: false
        },
        {
          id: 'scenario-analysis',
          title: 'Scenario Analysis',
          type: 'item',
          url: '/scenario-analysis',
          disabled: false
        },
        {
          id: 'scenario-comparison',
          title: 'Scenario Comparison',
          type: 'item',
          url: '/scenario-comparison',
          disabled: false
        },
        {
          id: 'scenario-playground',
          title: 'Scenario Playground',
          type: 'item',
          url: '/scenario-playground',
          disabled: false
        }
      ]
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'collapse',
      icon: icons.FileSearchOutlined,
      children: [
        {
          id: 'status-report',
          title: 'Status',
          type: 'item',
          url: '/status',
          disabled: false
        },
        {
          id: 'GapAnalysis',
          title: 'Gap Analysis',
          type: 'item',
          url: '/gap-analysis',
          disabled: false
        },
        {
          id: 'RoadAssessment',
          title: "Road Assessment",
          type: 'item',
          url: '/road-assessment',
          target: false
        }
      ]
    },
    // {
    //   id: 'alerts',
    //   title: 'Alerts',
    //   type: 'item',
    //   url: '/alerts',
    //   icon: icons.WarningOutlined,
    //   disabled: true
    // }
  ]
};

export default other;
